<template>
  <GModal class="custom-modal modal--tnc">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading">TERMS OF SERVICE</h2>
    </div>
    <div slot="body">
      <!-- <div class="body-content"></div> -->
      <div class="body-content">
        <h2 id="terms01" class="terms-conditions-heading">SYARAT DAN KETENTUAN UMUM PENGGUNAAN DAN AKSES</h2>
        <h2 class="terms-conditions-heading">PENDAHULUAN</h2>
        <p>
          Dengan menggunakan, mengakses atau mengunjungi situs www.soco.id
          <strong> (“SOCO”)</strong> atau produk, piranti lunak <i>(software)</i>, file data, dan layanan apapun yang
          tersedia untuk, kepada anda di, dari, atau melalui situs atau aplikasi yang terkait dengan, domain, atau
          setiap sub-domain dari Soco, termasuk namun tidak terbatas pada sociolla.com atau sub-domainnya (“Sociolla”),
          dan beautyjournal.id atau sub-domainnya <strong> (“Beauty Journal”),</strong> aplikasi SOCO by Sociolla
          <strong> (“Aplikasi”) </strong>(untuk selanjutnya seluruhnya atau sebagian disebut sebagai
          <strong>“Situs”</strong>) yang dijalankan dan dikelola oleh PT. Sociolla Ritel Indonesia, afiliasinya, penerus
          dan/atau penggantinya (untuk selanjutnya disebut sebagai <strong> “Kami”</strong>, atau
          <strong> “Perseroan”</strong>), anda telah menyatakan setuju dan sepakat terhadap:
        </p>

        <ol type="1">
          <li>
            <a href="#terms01"> Syarat dan Ketentuan Umum Penggunaan dan Akses ini; </a>
          </li>
          <li>
            <a href="#terms02"> Syarat dan Ketentuan Penggunaan dan Akses SOCO dan Sociolla; </a>
          </li>
          <li>
            <a href="#terms03"> Syarat dan Ketentuan Penggunaan dan Akses Beauty Journal; </a>
          </li>
          <li>
            <a href="#terms04"> Pedoman Isi Konten pada Beauty Journal; </a>
          </li>
          <li>
            ketentuan lain yang dapat diterbitkan oleh Perseroan setiap saat termasuk namun tidak terbatas pada setiap
            Kebijakan Privasi dan kebijakan keamanan sehubungan dengan penggunaan dan akses Situs yang dapat diatur
            secara terpisah <strong>(“Ketentuan Lain”).</strong>
          </li>
        </ol>

        <p>
          Seluruh syarat dan ketentuan sebagaimana dimaksud dalam poin (1) sampai dengan (5) di atas keseluruhannya
          merupakan satu kesatuan dan merupakan bagian yang tidak terpisahkan satu sama lain (yang selanjutnya disebut
          sebagai <strong>“Syarat dan Ketentuan”).</strong>
        </p>

        <p>Dengan menggunakan Situs ini anda setuju untuk tunduk pada Syarat dan Ketentuan ini.</p>

        <p>
          Kami dapat mengubah dan memodifikasi Syarat dan Ketentuan ini setiap saat. Anda setuju untuk tetap membaca
          ketentuan secara berkala guna mengetahui perubahan-perubahan terhadap Syarat dan Ketentuan. Anda mengakui dan
          sepakat untuk terikat pada perubahan atau revisi tersebut. Jika anda tidak setuju atas perubahan dan
          modifikasi tersebut, mohon untuk tidak menggunakan Situs Kami.
        </p>

        <h3 class="heading">1. Definisi</h3>

        <p>
          <strong>“Akun”</strong> adalah identitas <i>virtual</i> Pengguna pada Situs yang terdiri dari <i>username</i>,
          alamat <i>e-mail</i> dan <i>password</i>.
        </p>

        <p>
          <strong>“Data Pribadi” </strong> adalah data yang melekat pada individu Pengguna yang berupa nama, alamat,
          nomor telepon, alamat e-mail, nomor kartu kredit dan informasi rekening bank, data lokasi perangkat, riwayat
          pengiriman, barang yang terkirim, deskripsi barang yang diminta atau dibeli dan juga informasi log yang
          tersedia di server Kami, alamat protokol internet, informasi aktivitas perangkat, jenis peramban, tanggal dan
          waktu permintaan, URL perunjuk, sistem operasi, serta statistik halaman yang dilihat dan informasi lain yang
          akan berguna atau diperlukan.
        </p>

        <p>
          <strong>“Hari Kerja”</strong> berarti setiap hari (selain hari Sabtu atau Minggu) di mana bank-bank beroperasi
          di Jakarta.
        </p>

        <p>
          <strong>“Konten”</strong> adalah termasuk setiap file data, teks tertulis, piranti lunak (software) komputer,
          skrip, grafis, foto, suara, audio, musik, video, kombinasi audiovisual, fitur interaktif dan materi lain yang
          Anda dapat lihat, akses melalui atau kontribusikan ke dalam atau pada Layanan. Layanan termasuk semua aspek
          SOCO dan Beauty Journal, termasuk, namun tidak terbatas pada, semua produk, piranti lunak (software), fitur
          dan layanan yang ditawarkan melalui situs SOCO, Beauty Journal, ataupun setiap sub-domainnya, seperti namun
          tidak terbatas pada e-commerce platform, video uploader, video player dan aplikasi lainnya.
        </p>

        <p>
          <strong>“Pengguna”</strong> adalah setiap orang yang mendaftarkan dirinya pada Situs untuk menjadi anggota
          SOCO, termasuk namun tidak terbatas pada pembeli dan reviewer pada Situs.
        </p>

        <h3 class="heading">2. Situs</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Syarat dan Ketentuan berlaku untuk setiap Pengguna Situs, termasuk Pengguna yang merupakan: (i) pembeli yang
            melakukan pembelian melalui Situs, (ii) penjual yang melakukan penjualan melalui Situs, dan juga (iii)
            kontributor Konten pada Situs. Sebagai Pengguna, anda diperkenankan untuk mengirim, mengunggah atau
            mempublikasikan Konten ke dalam atau melalui Situs dan anda memahami bahwa Perseroan tidak menjamin
            kerahasiaan apapun sehubungan dengan Konten yang anda kirim, unggah atau publikasikan. Situs dapat memuat
            link/tautan ke situs pihak ketiga yang tidak dimiliki atau dikendalikan oleh Perseroan. Perseroan tidak
            memiliki kendali atas, dan tanggung jawab untuk setiap Konten, atau kegiatan atau praktik dari situs pihak
            ketiga tersebut. Selain itu, baik Perseroan tidak akan dan tidak dapat melakukan sensor atau menyunting
            terhadap konten dari situs pihak ketiga manapun. Dengan menggunakan Situs, anda telah secara tegas
            membebaskan Perseroan dari segala kewajiban yang timbul dari penggunaan dan data yang diperoleh oleh situs
            pihak ketiga.
          </li>
          <li>
            Tanpa mengurangi ketentuan yang lain sebagaimana terdapat di dalam Syarat dan Ketentuan, dalam menggunakan
            dan mengakses Situs, anda menyetujui hal-hal berikut ini:
            <ol type="1">
              <li>
                Anda menyetujui untuk tidak mendistribusikan dalam media apapun setiap bagian dari Situs atau Konten
                yang terdapat di dalamnya tanpa izin tertulis Perseroan terlebih dahulu kecuali apabila Perseroan
                menyediakan sarana untuk distribusi lebih lanjut tersebut melalui fungsionalitas yang ditawarkan di
                dalam Situs;
              </li>
              <li>
                Anda setuju untuk tidak mengubah atau memodifikasikan bagian manapun dari Situs namun mengizinkan
                Perseroan untuk mengubah, menyunting Konten untuk keperluan publikasi pada Situs;
              </li>
              <li>
                Anda setuju untuk tidak mengumpulkan atau mengambil informasi perorangan yang dapat diidentifikasi,
                termasuk namun tidak terbatas pada nama akun yang terdapat pada Situs;
              </li>
              <li>Dalam menggunakan Situs, anda patuh terhadap seluruh peraturan perundang-undangan yang berlaku;</li>
              <li>Perseroan berhak untuk menghentikan aspek apapun pada Situs kapan saja;</li>
              <li>
                Anda setuju untuk tidak menggagalkan, menonaktifkan atau mengintervensi fitur yang berhubungan dengan
                keamanan Situs atau fitur yang tersedia atau disediakan untuk mencegah atau membatasi penggunaan atau
                penyalinan Konten apapun atau yang tersedia atau disediakan untuk memberlakukan batasan pada penggunaan
                Situs atau Konten terkait; dan
              </li>
              <li>
                Anda memahami bahwa ketika anda menggunakan dan mengakses Situs, Anda akan memperoleh atau diperlihatkan
                Konten yang berasal dari berbagai sumber, dan bahwa Perseroan tidak bertanggung jawab atas keakuratan,
                kegunaan, keamanan, atau aspek hak atas kekayaan intelektual dari atau yang berkaitan dengan Konten
                tersebut. Anda selanjutnya memahami dan mengakui bahwa Anda mungkin memperoleh atau diperlihatkan Konten
                yang tidak akurat, tidak sopan, tidak senonoh, tidak pantas. Atas hal tersebut, dengan ini anda setuju
                untuk melepaskan, dan mengenyampingkan, setiap hak hukum atau hak keadilan yang Anda miliki atau mungkin
                Anda miliki untuk menuntut atau mempermasalahkan Perseroan terkait dengan hal tersebut, dan, sejauh
                diizinkan hukum yang berlaku, setuju untuk memberikan ganti rugi dan membebaskan Perseroan, pemilik,
                operator, afiliasi, pemasok/kontributor/pemilik lisensi, dan pemegang lisensi.
              </li>
            </ol>
          </li>
        </ol>

        <h3 class="heading">3. Akun Pada Situs</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Untuk dapat menggunakan dan mengakses layanan yang disediakan oleh Situs, anda harus membuat Akun pada SOCO.
            Ketika membuat Akun, anda diminta untuk memberikan informasi mengenai diri anda (seperti Data Pribadi atau
            rincian kontak), termasuk kepada face recognition atau voice recognition/voice recording sebagai bagian dari
            proses pendaftaran pada Situs atau sebagai bagian dari penggunaan Situs secara berkelanjutan oleh anda. Anda
            sepakat dan dengan ini menyatakan bahwa setiap informasi pendaftaran yang anda berikan melalui Situs adalah
            tepat, benar, dan terkini. Anda sepakat dan dengan ini menyatakan bahwa anda sepenuhnya bertanggung jawab
            (dan bahwa Perseroan tidak bertanggung jawab kepada anda atau kepada setiap pihak ketiga) atas seluruh
            aktivitas yang terjadi pada akun anda dan saat anda menggunakan akun.
          </li>
          <li>
            Dengan menyediakan data, mendaftarkan, dan membuat Akun SOCO, anda menjamin bahwa:
            <ol>
              <li>Anda berumur setidak-tidaknya 18 (delapan belas) tahun; atau</li>
              <li>
                Apabila Anda belum berusia 18 tahun, maka Anda akan dianggap telah mendapatkan persetujuan dari orang
                tua atau wali Anda untuk menyediakan data, mendaftarkan, membuat Akun SOCO, memberikan persetujuan
                terhadap Syarat dan Ketentuan (khususnya Kebijakan Privasi) menerima dan menggunakan Layanan. Sehubungan
                dengan hal ini, orang tua atau wali Anda dianggap telah setuju untuk bertanggung jawab atas Akun anda,
                seluruh aktifitas anda pada Situs/ Konten, dan penggunaan serta penerimaan terhadap Layanan oleh dan
                untuk anda.
              </li>
            </ol>
          </li>
          <li>
            Anda sepakat dan memahami bahwa anda bertanggung jawab untuk menjaga kerahasiaan kata sandi yang melekat
            pada setiap akun yang anda gunakan untuk menggunakan dan mengakses Situs. Jika anda mengetahui bahwa kata
            sandi atau Akun anda digunakan secara tidak sah atau anda mengetahui adanya usaha pelanggaran keamanan
            terhadap Akun anda, anda dapat segera memberitahukan Perseroan melalui alamat
            <i>e-mail</i> <a href="mailto:cs@sociolla.com">cs@sociolla.com</a>.
          </li>
        </ol>

        <h3 class="heading">4. Kebijakan Penghentian, Penutupan Akun, dan Penghapusan Konten</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Perseroan berhak menghentikan akses dan Akun pada Situs jika menurut Perseroan, Pengguna senantiasa
            melakukan pelanggaran.
          </li>
          <li>
            Perseroan berhak untuk memutuskan apabila Konten telah melanggar Syarat dan Ketentuan dengan berbagai alasan
            selain dari pelanggaran hak cipta, seperti, namun tidak terbatas pada pornografi, atau durasi yang terlalu
            panjang. Perseroan dapat, sewaktu-waktu, tanpa pemberitahuan sebelumnya dan atas kebijakan sendiri,
            menghapus Konten tersebut dan/atau menghapus Akun karena pelanggaran yang telah mengirimkan, mengunggah, dan
            mempublikasikan konten yang bertentangan dengan Syarat dan Ketentuan.
          </li>
        </ol>

        <h3 class="heading">5. Hak Kekayaan Intelektual, Lisensi untuk Konten, dan Hak Cipta</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Perseroan adalah pemilik tunggal atau pemegang lisensi yang sah atas semua hak pada Situs dan Kontennya
            dalam Situs. Semua Konten yang dimuat pada Situs, termasuk kekayaan intelektual, dilindungi oleh
            undang-undang hak cipta dan hukum yang berlaku di seluruh dunia yang melindungi kekayaan intelektual. Segala
            hak dan hak kekayaan intelektual terkandung dalam Situs dan Kontennya dimiliki oleh Perseroan. Seluruh hak
            yang tidak secara tegas dinyatakan dalam Syarat dan Ketentuan ini dilindungi diantaranya adalah sebagai
            berikut:
            <ol type="1">
              <li>kepemilikan atas seluruh perangkat lunak; dan</li>
              <li>
                nama "Sociolla" atau "sociolla.com", “SOCO” atau “soco.id”, “Beauty Journal”, ikon dan logo adalah merek
                dagang yang terdaftar di berbagai yurisdiksi dan dilindungi oleh undang-undang hak cipta, merek dagang,
                atau hak kekayaan intelektual lainnya. Dilarang keras untuk menggunakan, memodifikasi, atau menempatkan
                merek-merek di atas untuk kepentingan pribadi dan merusak Situs.
              </li>
            </ol>
          </li>
          <li>
            Anda menyetujui, menyatakan, dan menjamin bahwa anda memiliki sendiri atau memiliki lisensi, hak,
            persetujuan, dan izin untuk mempublikasikan Konten yang anda kirim atau unggah, dan anda sepakat untuk
            memberi lisensi yang dapat dialihkan, disublisensikan dan memberikan persetujuan kepada Perseroan untuk
            menggunakan atau memanfaatkan semua paten, hak cipta, merek dagang, rahasia dagang, hak merek atau hak
            kepemilikan lainnya dalam dan yang melekat pada Konten tersebut termasuk namun tidak terbatas untuk
            publikasi, distribusi, promosi, dan pengembangan bisnis Perseroan lebih lanjut.
          </li>
          <li>
            Anda akan tetap memegang semua hak kepemilikan dalam Konten anda. Namun, dengan mengirimkan, mengunggah atau
            mempublikasikan Konten pada Situs, anda menyatakan bahwa anda memberikan kepada Perseroan hak lisensi yang
            berlaku secara internasional (worldwide), non-eksklusif, bebas dari royalti, yang dapat disublisensikan dan
            dialihkan untuk menggunakan, mendistribusi, menampilkan dan menyelenggarakan Konten di media manapun
            sepanjang terkait dengan Situs atau bisnis Perseroan, termasuk, namun tidak terbatas pada, promosi dan
            redistribusi setiap bagian atau seluruh bagian dari Konten (dan setiap karya turunannya) dalam setiap format
            media dan melalui saluran media apapun. Anda dengan ini juga memberikan hak kepada Pengguna Situs suatu
            lisensi non-eksklusif untuk dapat mengakses Konten anda melalui Situs, dan untuk menggunakan, memproduksi
            kembali, mendistribusikan, dan menampilkan atau mempertontonkan Konten tersebut sebagaimana diizinkan
            melalui fungsionalitas Situs tertentu dan berdasarkan Syarat dan Ketentuan. Lisensi yang anda berikan di
            atas akan berakhir dalam jangka waktu yang wajar secara komersial setelah anda menghapus Konten dari Situs.
            Namun, Anda memahami dan setuju bahwa dengan berakhirnya lisensi sebagaimana dimaksud di atas, (i) D.
            Perseroan tidak berkewajiban untuk menarik kembali atau memastikan dihapusnya setiap bagian atau seluruh
            bagian dari Konten yang telah diproduksi kembali, didistribusikan, ditampilkan atau dipertontonkan di setiap
            media selain Situs, dan (ii) Perseroan tetap dapat menguasai dan menyimpan, tetapi tidak menampilkan,
            mendistribusikan, atau menyelenggarakan, salinan Konten anda yang telah dihapus. Pemberian lisensi di atas
            berlaku juga untuk komentar yang anda sampaikan dalam kolom pengguna, dan pemberian lisensi untuk komentar
            yang anda sampaikan dalam kolom pengguna berlaku secara terus-menerus (perpetual) dan tidak dapat dibatalkan
            atau diakhiri.
          </li>
          <li>
            Perseroan tidak memberikan dukungan, persetujuan, ataupun rekomendasi terhadap Konten apapun yang dikirim,
            diunggah atau dipublikasikan melalui Situs oleh Pengguna atau pemilik lisensi lainnya ataupun memberikan
            pendapat, atau saran untuk isi yang terkandung dalamnya, dan anda setuju bahwa Perseroan tidak memiliki
            setiap dan semua tanggung jawab sehubungan dengan Konten. Perseroan melarang dan tidak memperkenankan setiap
            bentuk pelanggaran terhadap hukum yang berlaku termasuk tetapi tidak terbatas pada hak cipta dan pelanggaran
            hak kekayaan intelektual lainnya untuk setiap Konten yang tersedia di Situs. Perseroan berhak sepenuhnya
            untuk membatasi, memblokir, atau menghentikan layanan dari setiap Akun Pengguna, melarang akses ke dalam
            Situs dan akan menghapus semua Konten jika ada pemberitahuan bahwa Akun Pengguna atau Konten tersebut telah
            melanggar ketentuan tersebut di atas. Perseroan berhak untuk menghapus Konten tanpa pemberitahuan sebelumnya
            serta mengambil langkah-langkah hukum untuk menjaga Pengguna atau pengunjung lainnya jika Kami menganggap
            bahwa pihak ketiga telah melanggar hukum yang berlaku termasuk tetapi tidak terbatas pada hak kekayaan
            intelektual sebagaimana diatur pada Syarat dan Ketentuan ini.
          </li>
          <li>
            Jika anda pemilik hak kekayaan intelektual (“HKI”) apapun termasuk hak cipta atau agennya atau kuasanya dan
            menganggap bahwa Konten yang terdapat di dalam Situs telah melanggar HKI anda, anda dapat mengirim
            pemberitahuan kepada Kami di alamat The St. Moritz Office Tower Unit 1502, Jl. Puri Indah Raya Blok U1,
            Kembangan, Jakarta 11610 dengan melampirkan dokumen-dokumen berikut ini:
            <ol type="1">
              <li>
                Surat kuasa yang menunjukkan bahwa pihak yang mengirimkan pemberitahuan berhak bertindak untuk dan atas
                nama pemilik HKI yang haknya dianggap telah dilanggar (jika dikuasakan);
              </li>
              <li>Identifikasi dari hasil HKI yang dianggap telah dilanggar;</li>
              <li>
                Identifikasi dari setiap materi atau konten yang dianggap telah melanggar hak cipta, dan segala
                informasi yang dianggap cukup oleh Perseroan untuk mengidentifikasi materi atau konten tersebut;
              </li>
              <li>
                Informasi yang dianggap cukup oleh Perseroan untuk dapat menghubungi anda, seperti alamat, nomor
                telepon, dan alamat surat elektronik;
              </li>
              <li>
                Surat pernyataan di atas meterai yang cukup yang menyatakan anda dengan itikad baik memiliki keyakinan
                bahwa penggunaan materi yang diadukan tersebut tidak sah dan tidak diizinkan atau dikuasakan oleh
                pemilik HKI, agennya, kuasanya atau peraturan perundang-undangan; dan
              </li>
              <li>
                Surat pernyataan di atas meterai yang cukup yang menyatakan bahwa pemberitahuan yang disampaikan adalah
                akurat, dapat dipertanggungjawabkan dan anda berhak bertindak untuk dan atas nama pemilik dari HKI yang
                haknya dianggap dilanggar.
              </li>
            </ol>
          </li>
          <li>
            Jika Anda menganggap Konten anda yang telah dihapus (atau yang telah dinonaktifkan aksesnya) tidak
            melanggar, atau anda memiliki wewenang atau kuasa dari pemilik HKI, agen pemilik HKI, atau berdasarkan
            hukum, untuk mempublikasi dan menggunakan materi dalam Konten, Anda diperbolehkan mengirimkan pemberitahuan
            tanggapan berisi informasi berikut kepada Perseroan:
            <ol type="1">
              <li>
                Identifikasi dari Konten yang telah dihapus atau yang aksesnya telah dinonaktifkan dan lokasi dimana
                Konten ditampilkan sebelum Konten tersebut dihapus atau dinonaktifkan;
              </li>
              <li>
                Surat pernyataan di atas meterai yang cukup yang menyatakan bahwa anda dengan itikad baik memiliki
                keyakinan bahwa penghapusan dan penonaktifan Konten karena adanya kesalahan atau kekeliruan dalam
                mengidentifikasi Konten; dan
              </li>
              <li>Nama, alamat, nomor telepon, dan alamat surat elektronik anda.</li>
            </ol>
          </li>
          <li>
            Jika pemberitahuan tanggapan diterima oleh Perseroan, Perseroan atau kuasanya dapat mengirimkan salinan
            pemberitahuan tanggapan kepada pihak yang mengajukan keluhan pertama dengan menginformasikan bahwa pihak
            tersebut dapat mengganti Konten yang telah dihapus atau mengaktifkan kembali akses dari Konten tersebut
            dalam waktu 10 (sepuluh) Hari Kerja. Kecuali pemilik HKI mengajukan tindakan hukum melalui pengadilan
            terhadap kontributor atau pengguna Konten maka Konten yang dihapus dapat digantikan, atau akses tersebut
            dipulihkan, waktu dalam 10 (sepuluh) sampai 14 (empat belas) Hari Kerja atau lebih setelah diterimanya
            pemberitahuan tanggapan, berdasarkan kebijakan dari Perseroan.
          </li>
        </ol>

        <h3 class="heading">6. Data Pribadi</h3>

        <p>Kami menghargai privasi Anda. Mohon baca kebijakan privasi Kami untuk informasi lebih lanjut.</p>

        <h3 class="heading">7. Penolakan</h3>

        <p>
          Perseroan dalam upaya terbaiknya akan senantiasa mengupayakan penyelenggaraan Situs yang dapat
          dipertanggungjawabkan secara hukum, namun demikian anda sepenuhnya menyadari dan setuju bahwa penggunaan Situs
          oleh anda sepenuhnya merupakan tanggung jawab anda sendiri dan berkaitan erat dengan keakuratan maupun
          kelengkapan seluruh data atau informasi termasuk Data Pribadi yang anda berikan. Dengan demikian, sejauh
          diperbolehkan oleh undang-undang, Perseroan serta petugas, direktur, komisaris, karyawan, dan agen Perseroan
          berhak menolak untuk memberikan segala bentuk jaminan dan menolak setiap tanggung jawab, baik yang ada secara
          tegas maupun tersirat, sehubungan dengan Situs dan penggunaan Situs oleh anda. Lebih lanjut, Perseroan tidak
          memberikan jaminan atau pernyataan tentang keakuratan, atau kelengkapan dari Situs serta tidak memiliki
          kewajiban dan tanggung jawab terhadap:
        </p>

        <ol type="A" class="privacy-listing">
          <li>
            cedera pribadi atau kerusakan properti yang bersifat apapun, yang timbul akibat dari akses dan penggunaan
            Situs oleh anda;
          </li>
          <li>
            setiap akses atau penggunaan server keamanan dan/atau setiap dan semua informasi pribadi dan/atau informasi
            keuangan yang tersimpan dalam server kami secara tidak sah;
          </li>
          <li>setiap gangguan atau berhentinya transmisi kepada atau dari Situs kami;</li>
          <li>
            setiap bugs, virus, trojan horse, atau sejenisnya yang dapat ditransmisikan kepada atau melalui Situs kami
            oleh pihak ketiga manapun;
          </li>
          <li>
            setiap kesalahan atau dihilangkannya suatu informasi dalam konten apapun atau untuk setiap kerugian atau
            kerusakan apapun yang terjadi sebagai akibat dari setiap penggunaan Konten yang dipublikasikan, diunggah,
            dikirim melalui e-mail, ditransmisikan, atau sebaliknya tersedia melalui layanan; dan/atau
          </li>
          <li>
            atas setiap pernyataan, serta ulasan/review yang ditulis, diunggah, dipublikasikan pada Situs baik oleh
            Pengguna atau pihak ketiga lainnya atas ketidakakuratan, ketidakbenaran, terhadap suatu produk yang terdapat
            pada Situs. Anda dengan ini memahami dan mengakui bahwa Perseroan tidak melakukan sunting atau filter
            terhadap setiap pernyataan serta ulasan/review yang ditulis, diunggah, dan dipublikasikan pada Situs oleh
            Pengguna atau pihak ketiga lainnya.
          </li>
        </ol>

        <h3 class="heading">8. Pembatasan Tanggung Jawab</h3>

        <p>
          Sesuai dengan pertimbangan tersebut pada bagian Penolakan, Perseroan serta petugas, direktur, komisaris,
          karyawan, atau agen Perseroan tidak memiliki tanggung jawab terhadap kerusakan ataupun kerugian yang apapun
          disebabkan oleh:
        </p>

        <ol type="A" class="privacy-listing">
          <li>kesalahan, kekeliruan, atau ketidakakuratan Konten;</li>
          <li>
            cedera pribadi atau kerusakan jenis properti apapun yang timbul akibat dari akses dan penggunaan Situs Kami
            oleh anda;
          </li>
          <li>
            setiap akses yang tidak sah atau penggunaan server keamanan kami dan/atau setiap dan semua informasi pribadi
            dan/atau informasi keuangan yang tersimpan dalam server kami secara tidak sah;
          </li>
          <li>setiap gangguan atau berhentinya transmisi kepada atau dari Situs Kami;</li>
          <li>
            setiap bugs, virus, trojan horse, atau sejenisnya yang dapat ditransmisikan kepada atau melalui layanan kami
            oleh pihak ketiga manapun; dan/atau
          </li>
          <li>
            setiap kesalahan atau dihilangkannya suatu informasi dalam Konten apapun atau untuk setiap kerugian atau
            kerusakan apapun yang terjadi sebagai akibat dari setiap penggunaan Konten yang dipublikasikan, diunggah,
            dikirim melalui e-mail, ditransmisikan, atau sebaliknya tersedia melalui layanan, baik berdasarkan jaminan,
            kontrak, atau karena alasan perbuatan melawan hukum (tort), meskipun Perseroan diberitahu tentang
            kemungkinan kerugian tersebut.
          </li>
        </ol>

        <p>
          Anda secara khusus mengakui Perseroan tidak akan bertanggung jawab atas Konten atau tindakan yang bertujuan
          untuk mencemarkan nama baik, penyinggungan, penyerangan (offensive), atau tindakan ilegal apapun oleh pihak
          ketiga dimana risiko bahaya atau kerusakan yang timbul dari hal-hal tersebut sepenuhnya merupakan tanggung
          jawab anda.
        </p>

        <p>
          Situs dikontrol oleh Perseroan dan merupakan salah satu fasilitas di Indonesia. Perseroan tidak memberikan
          pernyataan apapun tentang kesesuaian dan ketersediaan Situs di negara lain. Mereka yang mengakses atau
          menggunakan Situs dari yurisdiksi lain bertanggung jawab dalam mematuhi hukum yurisdiksi negara setempat.
        </p>

        <h3 class="heading">9. Ganti Rugi</h3>

        <p>
          Sejauh diizinkan oleh hukum yang berlaku, Anda setuju untuk membela, mengganti rugi dan membebaskan Perseroan,
          petugas, direktur, komisaris, karyawan dan agen Perseroan, dari dan terhadap setiap dan semua tuntutan,
          kerusakan, kewajiban, kerugian, tanggung jawab, biaya atau utang, dan biaya (termasuk, namun tidak terbatas
          pada, biaya konsultan hukum) yang timbul dari:
        </p>

        <ol type="A" class="privacy-listing">
          <li>penyalahgunaan Situs oleh anda;</li>
          <li>pelanggaran yang anda lakukan terhadap setiap atau semua ketentuan dari Syarat dan Ketentuan ini;</li>
          <li>
            pelanggaran oleh anda atas hak pihak ketiga, termasuk tanpa batasan terhadap HKI yang melekat padanya, hak
            milik, atau hak privasi;
          </li>
          <li>
            setiap pengaduan dan/atau penuntutan terhadap Konten yang anda kontribusikan yang mengakibatkan dampak
            kerugian bagi pihak ketiga; atau
          </li>
          <li>pelanggaran hukum dan undang-undang yang dapat berdampak kepada pihak ketiga.</li>
        </ol>

        <p>
          Kewajiban untuk membela dan memberikan ganti rugi sebagaimana dimaksud di atas akan terus berlaku walaupun
          Syarat dan Ketentuan dianggap berakhir dan anda tidak lagi menggunakan Situs.
        </p>

        <h3 class="heading">10. Kompetensi</h3>

        <p>
          Dengan menggunakan dan/atau mengakses Situs, anda dengan ini menyatakan dan menjamin bahwa anda adalah cakap
          untuk dan mampu mengikatkan dirinya dalam sebuah perjanjian yang sah menurut hukum, termasuk Syarat dan
          Ketentuan. Jika anda adalah sebuah institusi, atau badan hukum, anda telah memenuhi seluruh persyaratan yang
          ditetapkan oleh hukum dan dokumen korporasi anda untuk dapat mengikatkan badan hukum anda pada ketentuan dari
          Syarat dan Ketentuan.
        </p>

        <h3 class="heading">11. Hukum yang Berlaku</h3>

        <p>Syarat dan Ketentuan harus ditafsirkan dan diatur berdasarkan ketentuan hukum positif Republik Indonesia.</p>

        <h3 class="heading">12. Penyelesaian Sengketa</h3>

        <p>
          Anda setuju bahwa setiap pengaduan, tuntutan dan/atau sengketa antara anda dan Perseroan yang timbul
          seluruhnya atau sebagian dari atau terkait dengan Layanan akan terlebih dahulu diselesaikan secara musyawarah
          untuk mufakat. Apabila permasalahan tersebut tidak dapat diselesaikan secara kekeluargaan dalam waktu 30 (tiga
          puluh) hari setelah diadakannya musyawarah, para pihak sepakat untuk menyelesaikan pengaduan, tuntutan
          dan/atau sengketa tersebut pada Badan Arbitrase Nasional Indonesia (yang berkedudukan di Mampang Prapatan).
        </p>

        <h3 class="heading">13. Satu Kesatuan</h3>

        <p>
          Syarat dan Ketentuan Umum Penggunaan dan Akses ini, Syarat dan Ketentuan Penggunaan dan Akses SOCO dan
          Sociolla, Syarat dan Ketentuan Penggunaan dan Akses Beauty Journal, Pedoman Isi Konten pada Beauty Journal,
          dan Ketentuan Lain, merupakan keseluruhan perjanjian antara anda dan Perseroan tentang Situs.
        </p>

        <p>
          Jika ada suatu bagian ketentuan dari Syarat dan Ketentuan yang dianggap tidak sah oleh pengadilan yang
          berwenang, ketidakabsahan ketentuan tersebut tidak akan mempengaruhi keabsahan ketentuan lainnya dari Syarat
          dan Ketentuan, yang mana ketentuan lainnya tersebut akan tetap berlaku secara sah.
        </p>

        <div class="clear clearfix">&nbsp;</div>

        <h2 id="terms02" class="terms-conditions-heading text-center">
          SYARAT DAN KETENTUAN PENGGUNAAN DAN AKSES SOCO DAN SOCIOLLA
        </h2>

        <h3 class="heading">1. KETENTUAN PENGGUNAAN SITUS</h3>

        <p>
          Saat mengunjungi, menggunakan dan mengakses Situs, termasuk setiap fitur, aplikasi yang terkait dengan Situs
          tersebut dan layanannya, anda setuju untuk mematuhi ketentuan berikut ini;
        </p>

        <ol type="A" class="privacy-listing">
          <li>
            Akses Situs hanya diperkenankan untuk keperluan dan kepentingan berbelanja dan informasi terkait dengan
            layanan Situs;
          </li>
          <li>
            Anda tidak diperkenankan untuk memproduksi, mendistribusikan, memajang, menjual, menyewakan, mengirimkan,
            membuat karya turunan dari, menerjemahkan, memodifikasi, merekayasa balik, membongkar, mengurai atau
            mengeksploitasi Situs;
          </li>
          <li>
            Anda tidak diperkenankan untuk memuat dan menerbitkan Konten yang:
            <ol type="1">
              <li>melanggar hak cipta, paten, merek dagang, rahasia dagang, atau hak kekayaan intelektual lainnya;</li>
              <li>
                mengancam, rasis, cabul, tidak senonoh, pornografi atau lainnya yang dapat menimbulkan pelanggaran
                terhadap peraturan perundang-undangan Indonesia atau jurisdiksi lain;
              </li>
              <li>
                Mengandung bug, virus, worm, pintu perangkap, trojan horse atau kode dan properti berbahaya lainnya;
              </li>
              <li>
                Ketentuan lain yang bertentangan dengan Syarat dan Ketentuan dan/atau yang dilarang oleh ketentuan hukum
                yang berlaku.
              </li>
            </ol>
          </li>
          <li>
            Perseroan memiliki kewenangan untuk menghapus Konten yang Anda berikan atau menutup Akun Anda baik sementara
            maupun secara permanen apabila didapati adanya tindakan kecurangan dalam bertransaksi dan/atau pelanggaran
            terhadap Syarat dan Ketentuan yang ditetapkan oleh Perseroan.
          </li>
          <li>
            Perseroan, tanpa pemberitahuan terlebih dahulu kepada anda, memiliki kewenangan untuk melakukan tindakan
            yang perlu atas setiap dugaan pelanggaran Syarat dan Ketentuan dan/atau hukum yang berlaku, yang dapat
            berupa suspensi Akun, dan/atau penghapusan Akun pengguna sesuai dengan ketentuan hukum yang berlaku.
          </li>
          <li>
            Perseroan memiliki kewenangan untuk melakukan pembekuan saldo anda apabila ditemukan atau diduga adanya
            tindak kecurangan dalam bertransaksi dan/atau pelanggaran terhadap Syarat dan Ketentuan.
          </li>
          <li>
            Anda dilarang untuk menciptakan dan/atau menggunakan perangkat, software, fitur dan/atau alat lainnya yang
            bertujuan untuk melakukan manipulasi sistem Perseroan, termasuk namun tidak terbatas pada:
            <ol type="1">
              <li>manipulasi data barang;</li>
              <li>kegiatan perambanan (crawling/scraping);</li>
              <li>kegiatan otomatisasi dalam transaksi, promosi, dan hal lain yang serupa;</li>
              <li>penambahan produk ke etalase; dan/atau</li>
              <li>aktivitas lain yang secara wajar dapat dinilai sebagai tindakan manipulasi sistem.</li>
            </ol>
          </li>
        </ol>

        <h3 class="heading">2. KONTEN</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Dalam menggunakan setiap fitur dan/atau layanan yang terdapat dalam Situs, anda dilarang untuk mengunggah
            atau mempergunakan kata-kata, komentar, gambar, atau Konten apapun yang mengandung unsur SARA, diskriminasi,
            merendahkan atau menyudutkan orang lain, vulgar, bersifat ancaman, atau hal-hal lain yang dapat dianggap
            tidak sesuai dengan nilai dan norma sosial, dan yang bertentangan dengan Syarat dan Ketentuan dan juga hukum
            yang berlaku. Perseroan berhak melakukan tindakan yang diperlukan atas pelanggaran ketentuan ini, antara
            lain penghapusan Konten, pemblokiran akun, dan tindakan-tindakan lain yang dianggap perlu oleh Perseroan.
          </li>
          <li>
            Seluruh komentar, review yang dituliskan, gambar, video dan/atau foto yang di unggah pada Situs akan
            dikategorikan dan diperlakukan sebagai Konten yang bersifat tidak rahasia. Seluruh Konten yang diunggah pada
            Situs menjadi hak kami.
          </li>
          <li>Anda dilarang menulis Konten pada Situs dengan menggunakan Akun orang lain.</li>
          <li>
            Anda dilarang membuat Konten termasuk memuat gambar yang mengandung kalimat atau penghinaan terhadap
            Perseroan, Situs, atau pihak ketiga lainnya.
          </li>
          <li>
            Anda dilarang membuat Konten termasuk menggunakan foto/gambar barang yang memiliki watermark yang menandakan
            atau memang yang merupakan hak kepemilikan orang lain.
          </li>
          <li>
            Perseroan berhak untuk menghapus Konten yang mengandung unsur yang tidak layak tayang sebagaimana dimaksud
            di butir A hingga E di atas.
          </li>
          <li>
            Anda dengan ini memahami dan menyetujui bahwa penyalahgunaan Konten yang di unggah oleh Anda adalah tanggung
            jawab Anda secara pribadi.
          </li>
          <li>
            Anda menjamin bahwa Anda tidak melanggar hak kekayaan intelektual dalam mengunggah Konten kedalam Situs.
            Anda dengan ini bertanggung jawab secara pribadi atas pelanggaran hak kekayaan intelektual dalam mengunggah
            Konten pada Situs.
          </li>
          <li>
            Meskipun kami mencoba untuk menawarkan informasi yang lengkap, kami tidak dapat menjanjikan dan menjamin
            bahwa katalog dan/atau informasi pada Situs akan selalu akurat dan termutakhir, dan Anda setuju bahwa Anda
            tidak akan meminta Perseroan bertanggung jawab atas ketimpangan, kekeliruan, atau kesalahan informasi dalam
            Situs. Segala informasi dalam Situs mungkin termasuk hak cipta, merek dagang atau hak milik lainnya.
          </li>
        </ol>

        <h3 class="heading">3. PENGGUNA FIRST CLIQUE, FAB CLIQUE, GLAM CLIQUE, ROYAL CLIQUE</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Menjadi Pengguna atau anggota yang disebut dengan First Clique, Fab Clique, Glam Clique dan Royal Clique
            (selanjutnya secara bersama-sama disebut sebagai <strong>“SOCO Clique”</strong>) tidak dikenai biaya.
          </li>
          <li>
            Anggota SOCO Clique tidak diizinkan untuk menjual, berupaya menjual, menawarkan untuk menjual, memberikan,
            mengirim atau mentransfer Akun, ID Pengguna atau kata sandi kepada pihak ketiga mana pun tanpa sepengetahuan
            dan pemberitahuan tertulis sebelumnya dari Kami. Kami dapat menangguhkan atau menghentikan Akun Pengguna
            jika Kami mengetahui bahwa Akun Pengguna SOCO Clique telah dijual, ditawarkan untuk dijual, diberikan,
            dikirim atau ditransfer yang dianggap sebagai pelanggaran terhadap ketentuan Pasal ini. Untuk informasi
            lebih lanjut tentang SOCO Clique, silakan kunjungi situs Kami.
          </li>
          <li>
            Kami dapat mengubah dan memodifikasi Syarat dan Ketentuan ini setiap saat. Anda setuju untuk tetap membaca
            ketentuan secara berkala guna mengetahui perubahan-perubahan terhadap Syarat dan Ketentuan. Anda mengakui
            dan sepakat untuk terikat pada perubahan atau revisi tersebut. Jika anda tidak setuju atas perubahan dan
            modifikasi tersebut, mohon untuk tidak menggunakan Situs Kami.
          </li>
          <li>
            Setiap anda melakukan transaksi pada Situs, anda akan menerima sejumlah poin tertentu
            <strong>(“SOCO Points”)</strong>. Jika dalam waktu 2 x 24 jam anda tidak menerima SOCO Points pada Akun
            anda, anda dapat melaporkannya dengan menghubungi customer service Kami di cs@sociolla.com atau hubungi Kami
            di Technical Center No. (021) 2931 9208 untuk mengajukan keluhan lebih lanjut.
          </li>
        </ol>

        <h3 class="heading">4. TRANSAKSI PEMBELIAN</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Kecuali secara jelas dinyatakan sebaliknya, harga yang tertera di Situs belum termasuk pajak, ongkos kirim,
            tarif armada ataupun kurir ke luar kota (ekspedisi) dari jasa mana pun.
          </li>
          <li>
            Apabila dalam kondisi tertentu seperti tetapi tidak terbatas pada adanya kesalahan penulisan informasi
            tentang harga atau tentang suatu produk, atau adanya transaksi yang menurut kami secara sepihak patut diduga
            sebagai transaksi yang melanggar peraturan peraturan perundang-undangan, Syarat dan Ketentuan, kesusilaan
            serta itikad baik, maka Kami memiliki hak untuk menolak atau membatalkan pesanan termasuk dalam kondisi di
            mana anda telah melakukan pembayaran. Dalam hal pembatalan tersebut kami lakukan dan pembayaran atas
            transaksi telah kami terima, maka kami akan melakukan refund atau pengembalian dana kepada rekening asal
            pembayaran tersebut atau sesuai dengan ketentuan yang diatur dalam Syarat dan Ketentuan ini.
          </li>
          <li>
            Untuk pembelian online melalui shopping cart, pesanan dan pengiriman akan diproses setelah pembayaran
            diterima oleh rekening bank atas nama Perseroan dan pembeli memberikan konfirmasi pembayaran melalui e-mail
            ke cs@sociolla.com. Lama waktu pengiriman disesuaikan dengan area layanan daerah tujuan. Untuk pengiriman
            yang menggunakan ekspedisi, kami bekerja sama dengan pihak jasa kurir.
          </li>
          <li>
            Kami selalu berusaha dengan upaya terbaik Kami untuk memastikan bahwa informasi yang terdapat di dalam
            katalog belanja pada Situs adalah jelas dan akurat namun Kami tidak dapat memberikan jaminan bahwa informasi
            tersebut, termasuk kepada spesifikasi produk dan editorial, akan selalu akurat.
          </li>
          <li>
            Sebagian barang bisa saja merupakan barang yang tidak selalu tersedia sehingga diperlukan pemesanan terlebih
            dahulu. Apabila barang yang anda cari tidak tersedia pada Situs, tim Kami siap untuk membantu anda untuk
            melakukan pemesanan barang tersebut, dengan begitu Kami tetap bisa memberikan layanan terbaik untuk anda.
          </li>
          <li>
            Barang yang telah dibeli tidak dapat dikembalikan atau ditukar dengan barang lain, kecuali apabila memenuhi
            ketentuan sebagaimana diatur pada Syarat dan Ketentuan ini.
          </li>
          <li>
            Pengguna akan menerima <i>e-mail</i> notifikasi mengenai Nomor Resi Pengiriman sesaat setelah produk pesanan
            Pengguna dikirim. Tarif pengiriman, apabila berlaku, akan digabungkan dengan total jumlah yang harus dibayar
            pada saat diselesaikannya proses belanja.
          </li>
          <li>
            Tarif pengiriman dapat digratiskan apabila total harga belanja mencapai harga minimum yang telah ditentukan
            oleh Perseroan.
          </li>
          <li>
            Perseroan berhak melakukan pembatalan transaksi kartu kredit apabila terdapat transaksi pembelian barang
            dengan menggunakan kartu kredit yang menurut Perseroan melanggar ketentuan hukum yang berlaku.
          </li>
          <li>
            Jika barang yang anda pesan mengalami kerusakan atau kekeliruan pada saat penerimaan barang, silahkan
            menghubungi kami melalui e-mail di
            <a mailto="cs@sociolla.com">cs@sociolla.com</a> dan customer service akan membantu anda tentang masalah anda
          </li>
          <li>
            Setelah mendapatkan arahan dari customer service, kami akan berkoordinasi untuk melakukan penggantian barang
            yang rusak. Proses penggantian ini dapat memakan waktu paling lama 10 (sepuluh) Hari Kerja dan tidak
            termasuk proses logistik kurir untuk mengantarkan barang kembali kepada anda yang dapat memakan waktu 1
            (satu) hingga 2 (dua) Hari Kerja untuk daerah Jabodetabek, dan 2 (dua) hingga 5 (lima) Hari Kerja untuk
            daerah di luar Jabodetabek. Kami akan menghubungi anda, apabila terjadi keterlambatan pengiriman dikarenakan
            sebab apapun yang menghambat pengiriman barang tepat waktu. Kami tidak bertanggung jawab dalam hal terjadi
            keterlambatan pengiriman barang pengganti kepada Anda yang disebabkan karena kelalaian atau kesalahan vendor
            atau jasa kurir. Adapun tarif pengiriman tersebut akan kami tanggung sebagai kompensasi ganti rugi anda
          </li>
          <li>
            Kami tidak bertanggung jawab dan tidak memiliki kewajiban apapun untuk setiap kerugian terhadap anda yang
            timbul dari informasi pengiriman dan/atau informasi pembayaran yang dimasukkan oleh anda atau pengiriman
            uang yang salah oleh anda sehubungan dengan pembayaran untuk barang yang dibeli. Kami berhak untuk memeriksa
            apakah anda berwenang untuk menggunakan metode pembayaran tertentu, dan dapat menangguhkan transaksi sampai
            otorisasi tersebut dikonfirmasi atau membatalkan transaksi yang bersangkutan bila konfirmasi tersebut tidak
            tersedia.
          </li>
          <li>
            Perseroan berhak melakukan pembatalan transaksi secara sepihak dan tanpa pemberitahuan apabila terdapat
            transaksi pembelian yang menurut Perseroan mencurigakan dan melanggar ketentuan hukum yang berlaku.
          </li>
        </ol>

        <h3 class="heading">5. DESKRIPSI PRODUK</h3>

        <p>
          Sociolla selalu berusaha untuk memberikan deskripsi produk selengkap mungkin. Tetapi kami tidak dapat
          memberikan jaminan mutlak bahwa semua deskripsi atau Konten yang terkandung di situs web ini
          tepat/lengkap/terkini/ atau bebas dari kesalahan. Jika produk yang ditawarkan di Situs tidak sesuai dengan
          deskripsi produk, maka Anda dapat mengembalikan produk dalam kondisi segel yang tidak digunakan atau dibuka.
        </p>

        <h3 class="heading">6. KETERSEDIAAN BARANG</h3>

        <p>
          Untuk mempertahankan daya saing situs web Kami, sulit bagi Kami untuk selalu menyediakan semua item di dalam
          Situs. Staf Kami akan dengan senang hati memberitahu anda jika ada produk yang perlu dipesan dan jangka waktu
          pengiriman yang dibutuhkan. Kami percaya bahwa hanya dengan cara ini Kami dapat mempertahankan penawaran
          terbaik untuk pelanggan Kami.
        </p>

        <h3 class="heading">7. HARGA</h3>

        <ol type="A" class="privacy-listing">
          <li>
            Pengguna memahami dan menyetujui bahwa kesalahan keterangan harga dan informasi lainnya yang disebabkan
            tidak terbaharuinya halaman Situs dikarenakan browser/ISP yang dipakai Pengguna adalah tanggung jawab
            Pengguna.
          </li>
          <li>
            Dengan melakukan pemesanan melalui Situs, anda menyetujui untuk membayar total biaya yang harus dibayarkan
            sebagaimana tertera dalam halaman pembayaran, yang dapat terdiri dari harga barang, ongkos kirim, dan biaya
            lainnya.
          </li>
          <li>
            Biaya lain yang mungkin timbul dan akan diuraikan secara tegas dalam halaman pembayaran. Anda setuju untuk
            melakukan pembayaran melalui metode pembayaran yang telah dipilih sebelumnya oleh anda. Dengan memilih
            metode pembayaran menggunakan alat pembayaran yang melibatkan pihak lembaga keuangan, maka anda berarti
            memberikan persetujuan bagi Kami untuk mentransfer data/informasi pribadi anda yang berada dalam
            kepemilikan/penguasaan Kami kepada pihak lembaga keuangan terkait untuk tujuan pemrosesan pembayaran
            dan/atau keperluan insidentil lainnya terkait transaksi anda melalui Situs Kami.
          </li>
          <li>Situs untuk saat ini hanya melayani transaksi jual beli Barang dalam mata uang Rupiah.</li>
        </ol>

        <h3 class="heading">8.PENGEMBALIAN BARANG / <i>RETURN POLICY</i></h3>

        <ol type="A" class="privacy-listing">
          <li>
            Pengguna dapat melakukan penukaran produk atau pengembalian produk, dengan ketentuan sebagaimana berikut:
            <ol type="1">
              <li>Produk yang diterima tidak sesuai dengan pemesanan yang dilakukan oleh Pengguna;</li>
              <!-- <li>Masa kadaluarsa produk yang diterima oleh Pengguna dibawah 1 (satu) tahun;</li> -->
              <li>Produk yang diterima melebihi kuantiti yang seharusnya didapatkan oleh Pengguna;</li>
              <li>
                Adanya kerusakan atau ketidaksesuaian pada produk yang diterima oleh Pengguna, termasuk namun tidak
                terbatas kepada:
                <ol type="A" class="privacy-listing">
                  <li>
                    Jumlah produk yang diterima oleh Pengguna kurang dari jumlah produk yang dipesan melalui Situs;
                  </li>
                  <li>Produk pecah atau rusak saat diterima;</li>
                  <li>Isi volume produk tidak sesuai dengan pesanan yang dilakukan oleh Pengguna;</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            Pengguna dapat melakukan proses pengembalian produk dengan cara mengirimkan keluhan melalui alamat email
            <a href="mailto:cs@sociolla.com">cs@sociolla.com</a> . Adapun informasi yang harus diberikan oleh Pengguna
            terkait keluhan adalah Pengguna harus (i) melampirkan foto produk; (ii) melampirkan foto masa kadaluarsa,
            (iii) nomor pesanan/nama akun SOCO, termasuk kepada informasi alamat untuk mengirimkan barang yang baru;
            (iv) dan hal terkait lainnya.
          </li>
          <li>
            Pengguna wajib melakukan permintaan pengembalian produk maksimal 1 x 24 jam sejak barang diterima oleh
            Pengguna. Sociolla berhak untuk tidak melakukan proses pengembalian barang jika Pengguna melakukan pengaduan
            lebih dari 1x24 jam setelah barang diterima.
          </li>
          <li>
            Sociolla berhak untuk tidak melanjutkan proses pengembalian barang jika Pengguna tidak memenuhi Syarat dan
            Ketentuan ini.
          </li>
        </ol>

        <div id="terms03" class="clear clearfix">&nbsp;</div>

        <h2 class="terms-conditions-heading text-center">SYARAT DAN KETENTUAN PENGGUNAAN DAN AKSES BEAUTY JOURNAL</h2>

        <h3 class="heading">1. Hal-hal yang Dapat Dilakukan dan Tidak Dapat Dilakukan</h3>

        <p>
          Perseroan dengan ini mengizinkan anda untuk mengakses dan menggunakan setiap layanan yang tersedia pada Beauty
          Journal berdasarkan Syarat dan Ketentuan sebagai berikut:
        </p>

        <ol type="A" class="privacy-listing">
          <li>
            Anda setuju untuk tidak mengakses Konten melalui teknologi atau sarana apapun selain daripada video playback
            pages dari Beauty Journal itu sendiri atau sarana resmi lainnya yang ditetapkan atau diperbolehkan oleh
            Perseroan atau tersedia pada Beauty Journal;
          </li>
          <li>
            Anda setuju untuk tidak menggunakan dan mengakses Beauty Journal yang bertentangan dengan Syarat dan
            Ketentuan atau nilai-nilai yang diterapkan oleh Perseroan;
          </li>
          <li>
            Anda sepakat untuk tidak menghapus Konten pada Beauty Journal dalam periode tertentu sebagaimana ditentukan
            oleh Perseroan;
          </li>
          <li>
            Hal-hal di bawah ini dapat anda lakukan sebagai Pengguna:
            <ol type="1">
              <li>
                mengunggah/upload video asli ke situs Beauty Journal, atau mempertahankan saluran asli di Beauty
                Journal, untuk mempromosikan bisnis atau artistic enterprise;
              </li>
              <li>
                menunjukkan atau memasang video yang dapat diakses melalui fitur tertentu seperti misalnya embeddable
                player dari situs manapun; atau
              </li>
              <li>Penggunaan apapun yang telah diberi izin tertulis oleh Perseroan.</li>
            </ol>
          </li>
          <li>
            Jika anda menampilkan video yang dapat ditampilkan dengan atau berdasarkan teknologi embeddable player
            ataupun teknologi sejenisnya di situs Beauty Journal, anda dilarang untuk melakukan modifikasi, memotong,
            atau memblokir sebagian atau fungsi dari embeddable player ataupun teknologi sejenisnya tersebut, termasuk
            namun tidak terbatas pada tautan/link kembali ke situs pihak ketiga yang menyediakan fitur embeddable player
            atau teknologi sejenis tersebut.
          </li>
          <li>
            Apabila anda mengunggah Konten pada situs Beauty Journal, maka anda sepakat bahwa anda tidak akan
            mempublikasikan Konten yang sama pada situs pihak ketiga kecuali pada situs youtube.com (ataupun setiap
            sub-domainnya), blog pribadi anda, atau social media pribadi anda.
          </li>
        </ol>

        <h3 class="heading">2. Penggunaan Konten dan Perilaku</h3>

        <p>
          Sebagai tambahan dari ketentuan di atas, berikut adalah ketentuan dan larangan-larangan yang berlaku secara
          khusus terhadap penggunaan Konten oleh anda.
        </p>

        <ol type="A" class="privacy-listing">
          <li>
            Konten pada Beauty Journal, merek dagang, merek layanan, logo, nama domain, dan fitur merek khas lain yang
            terdapat pada situs Beauty Journal dimiliki oleh, dilisensikan, atau disub-lisensikan kepada Perseroan,
            dengan tetap tunduk pada ketentuan perlindungan hak cipta dan hak kekayaan intelektual lainnya berdasarkan
            hukum yang berlaku.
          </li>
          <li>
            Konten yang ditampilkan kepada anda dapat berupa Konten yang sudah diubah, diedit atau dikurasi oleh
            Perseroan. Anda tetap dapat mengakses Konten untuk informasi dan penggunaan pribadi sebagaimana dimaksud
            melalui fungsionalitas Beauty Journal dan berdasarkan Syarat dan Ketentuan. Anda tidak diperbolehkan
            mengunduh Konten kecuali jika Anda melihat tanda “download” atau link/tautan serupa yang disediakan oleh
            Perseroan di dalam Beauty Journal yang menjalankan Konten tersebut. Anda tidak diperbolehkan menyalin
            (copy), memperbanyak (reproduce), mendistribusikan (distribute), mengirimkan (transmit), menyiarkan
            (broadcast), memperlihatkan (display), menjual (sell), mengizinkan (license), atau mengeksploitasi (exploit)
            Konten apapun untuk tujuan lain tanpa persetujuan tertulis terlebih dahulu dari Perseroan dan/atau
            pemasok/kontributor/pemilik lisensi dari masing-masing Konten. Perseroan, pemasok/kontributor dan pemilik
            lisensi memiliki semua hak yang secara tegas tidak diberikan pada Konten.
          </li>
          <li>
            Anda selanjutnya setuju bahwa Konten yang anda serahkan dalam Beauty Journal tidak berisi materi yang
            merupakan hak cipta dari pihak ketiga, atau materi yang tunduk pada hak kepemilikan pihak ketiga lainnya,
            kecuali anda memiliki izin dari pemilik materi yang berhak atau anda secara hukum berhak untuk mengirimkan,
            mengunggah atau mempublikasikan materi tersebut dan untuk mengizinkan Perseroan untuk memanfaatkan semua hak
            lisensi yang diberikan kepadanya.
          </li>
          <li>
            Anda selanjutnya setuju bahwa anda tidak akan mengirimkan, mengunggah atau mempublikasikan Konten atau
            materi lain yang bertentangan dengan Syarat dan Ketentuan, yang dapat diperbaruhi dari sewaktu-waktu, atau
            bertentangan dengan hukum lokal, nasional, dan internasional yang berlaku.
          </li>
        </ol>

        <div class="clear clearfix">&nbsp;</div>

        <h2 id="terms04" class="terms-conditions-heading text-center">
          SYARAT DAN KETENTUAN ISI KONTEN PADA BEAUTY JOURNAL
        </h2>

        <h3 class="heading">1. Konten yang Merugikan, Berbahaya, atau Berbau Kekerasan</h3>

        <p>
          Kami dapat membatasi Konten yang bermaksud menipu, menghasut kekerasan atau mendorong kegiatan berbahaya atau
          ilegal, yang berisiko mengakibatkan cedera fisik yang serius atau kematian.
        </p>

        <p>
          Kami melarang keras mengunggah video atau Konten lainnya untuk menghasut orang lain untuk melakukan tindakan
          kekerasan atau kriminalitas lainnya. Jika Konten anda mengajak orang lain untuk melakukan tindakan kekerasan
          atau mengancam orang dengan tindakan kekerasan yang serius atau tindakan kriminalitas lainnya, Konten tersebut
          akan dihapus dari Situs.
        </p>

        <p>
          Kami sangat peka terhadap semua Konten yang merugikan atau berbahaya yang melibatkan anak di bawah umur.
          Contohnya, jika video anda menunjukkan adanya anak di bawah umur melakukan aktivitas yang merugikan atau
          berbahaya, mohon untuk tidak mengunggah video tersebut. Demi melindungi anak di bawah umur, kami dapat
          mengenakan pembatasan usia pada video yang berisi orang dewasa yang melakukan kegiatan yang berisiko tinggi
          yang dapat mengakibatkan cedera atau kematian.
        </p>

        <h3 class="heading">2. Konten seksual</h3>

        <p>Konten yang bertujuan untuk merangsang secara seksual dilarang untuk ditampilkan di situs Beauty Journal.</p>

        <h3 class="heading">3. Perkataan yang mendorong kebencian dan/atau bertentangan dengan hukum</h3>

        <p>
          Kami mendukung kebebasan berbicara dan membela hak anda untuk menyatakan pandangan yang tidak populer. Namun,
          kami melarang perkataan yang mendorong atau menyatakan ujaran kebencian.
        </p>

        <p>
          Perkataan yang mendorong kebencian mengacu pada Konten yang menyerukan kekerasan atau kebencian terhadap
          individu atau kelompok berdasarkan atribut tertentu, seperti:
        </p>

        <ol type="A" class="privacy-listing">
          <li>ras atau etnis asal;</li>
          <li>agama;</li>
          <li>kecacatan;</li>
          <li>jenis kelamin;</li>
          <li>usia;</li>
          <li>status veteran;</li>
          <li>orientasi seksual/identitas gender; dan</li>
          <li>
            perkataan atau ujaran lain yang dimaksudkan untuk menimbulkan rasa kebencian kepada kelompok masyarakat
            tertentu.
          </li>
        </ol>

        <p>
          Setiap Konten yang bertentangan dengan hukum tidak dapat Kami terima dan Kami berhak dengan kebijaksanaan
          mutlak untuk menghapus Konten tersebut dari Situs.
        </p>

        <h3 class="heading">4. Ancaman</h3>

        <p>
          Konten yang berisi ancaman bahaya fisik yang serius terhadap seseorang atau sekelompok orang tertentu akan
          dihapus. Orang yang mengancam orang lain dapat menerima teguran pada Akunnya, dan Akun tersebut dapat
          dihentikan.
        </p>

        <h3 class="heading">5. <i>Spam,</i> Praktik Penipuan, dan <i>Scam Spam</i> video dan Komentar</h3>

        <p>
          Anda tidak boleh mengunggah Konten yang tidak bertarget, tidak diinginkan, atau berulang dalam jumlah besar
          pada video, komentar, pesan pribadi, atau tempat-tempat lain di situs Beauty Journal. Jika tujuan utama Konten
          anda adalah untuk mengarahkan pengguna Situs ke situs lain, hal tersebut melanggar kebijakan spam kami.
        </p>

        <h3 class="heading">6. <i>Artificial Traffic Spam</i></h3>

        <p>
          Segala sesuatu yang meningkatkan jumlah tayangan, suka, komentar, atau metrik lainnya secara tidak wajar
          melalui penggunaan sistem otomatis bertentangan dengan Syarat dan Ketentuan Kami. Konten dan Akun yang
          melanggar Syarat dan Ketentuan ini dapat ditutup dan dihapus dari Beauty Journal.
        </p>

        <h3 class="heading">7. Metadata yang menyesatkan</h3>

        <p>
          Metadata mengacu pada setiap dan semua informasi tambahan yang disediakan di video. Informasi ini mencakup
          judul, uraian, tag, anotasi, dan gambar mini. Semua metadata harus mewakili Konten yang terkandung di video
          anda. Pilih jumlah tag yang sesuai yang paling menggambarkan Konten video anda. Selain itu, cukup tambahkan
          tag ke bagian tag metadata anda. Penambahan tag pada deskripsi video Anda dapat dianggap sebagai spam dan
          dapat menyebabkan video anda dihapus.
        </p>

        <h3 class="heading">8. Scam</h3>

        <p>
          Beberapa pengguna membuat konten yang mencoba mengelabui orang lain guna mendapatkan keuntungan finansial
          untuk dirinya. Konten yang secara sengaja mencoba menyesatkan pengguna untuk mendapatkan keuntungan finansial
          dapat dihapus, dan dalam beberapa kasus, teguran dapat dikeluarkan kepada orang yang mengunggah Konten
          tersebut.
        </p>

        <h3 class="heading">9. Pelaporan</h3>

        <p>
          Anda dapat melaporkan video yang diyakini melanggar kebijakan ini, jika anda menemukan beberapa video,
          komentar, atau seluruh Akun Pengguna yang ingin dilaporkan atau anda yakini sebagai spam dan scam, dengan
          menghubungi Kami melalui alamat e-mail cs@sociolla.com untuk mengajukan keluhan lebih lanjut.
        </p>
      </div>
    </div>
  </GModal>
</template>
<script>
export default {
  name: 'modal-tnc',
  data() {
    return {
      active: true,
    };
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'tnc' });
    },
  },
};
</script>
<style lang="scss">
@import 'privacy-policy';

h3 {
  width: 100%;
  display: block;
}
</style>
